// extracted by mini-css-extract-plugin
export default {"clearLink":"SearchForm-module__clearLink--imAjH","buttonMargin":"SearchForm-module__buttonMargin--oxpKs"};